<template>
  <div class="list">
    <van-search placeholder="请输入搜索关键词" v-model="textKey" @search="search" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell
        v-for="(item, index) in list"
        :key="index"
        :title="item.name"
        :label="item.standardTime | format"
        @click="goUrl(item.id)"
      >
        <template slot="icon">
          <van-image :src="img" fit="scale-down" />
        </template>
      </van-cell>
    </van-list>
    <div class="dialog" v-show="isExist">
      <img src="../../assets/404.svg" class="mt" />
      <div class="tishi">
        <p>空空如也</p>
      </div>
    </div>
  </div>
</template>
<script>
import { assessApi } from '@/api/index'
import weixinshare from '@/wxsdk/share'
export default {
  data() {
    return {
      isExist: false,
      textKey: '',
      list: [],
      loading: false,
      finished: false,
      gradeId: 0,
      subjectId: 0,
      pageStart: 0,
      pageSize: 10,
      page: 1,
      img: ''
    }
  },
  mounted() {
    this.gradeId = this.$route.params.gid
    this.subjectId = this.$route.params.sid
    if (this.subjectId == 1) {
      this.img = require('../../assets/math_on.svg')
    } else if (this.subjectId == 3) {
      this.img = require('../../assets/chemi_on.svg')
    } else {
      this.img = require('../../assets/physics_on.svg')
    }
    const linkurl = window.location.href
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs)
  },
  methods: {
    search() {
      this.page = 1
      this.onLoad()
    },
    onLoad() {
      this.pageStart = (this.page - 1) * this.pageSize
      let params = {
        gradeId: this.gradeId,
        subjectId: this.subjectId,
        name: this.textKey,
        start: this.pageStart,
        length: this.pageSize
      }
      assessApi.getSpecialPlanList(params).then(res => {
        if (res.success) {
          this.list = [...res.data]
          if (this.pageStart !== 0) {
            this.page++
          }
          // 加载状态结束
          this.loading = false
          // console.log("////////////////" + this.list.length);
          if (this.list.length >= res.recordsTotal) {
            this.finished = true
          }
        } else {
          if (res.code == 20002) {
            this.isExist = true
          } else {
            this.$toast.fail('无法获取列表数据')
          }
        }
      })
    },
    goUrl(id) {
      this.$router.push({
        name: 'info',
        params: { id: id }
      })
    }
  },
  filters: {
    format: function(value) {
      let str = '最佳用时：'
      if (value > 60) {
        let i = parseInt(value / 60)
        let m = value - 60 * i
        return str + i + '分' + m + '秒'
      } else {
        return str + value + '秒'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  .van-cell {
    /deep/ .van-image__img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }
}
.dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  background-color: #fff;
  color: #606266;
  img {
    width: 50%;
    margin: 20px auto;
    display: block;
  }
  img.mt {
    margin-top: 100px;
  }
  .tishi {
    text-align: center;
    font-size: 14px;
    line-height: 15px;
  }
}
</style>
